import React, { useEffect, useRef, useState } from "react";
import Loader from "../Utils/Loader";
import { CustomGetAPI, CustomPostAPI } from "../Utils/APIConnector";
import VenueOwnerDashbooard from "./VenueOwnerDashbooard";
import VenueOwnerDashbooardBooking from "./VenueOwnerDashbooardBooking";
import StaffMembers from "../StaffMembers/StaffMembers";
import VenueDashboardEditDetails from "./VenueDashboardEditDetails";
import PackagesDetails from "./PackagesDetails";
import VenueOwnerPlanListing from "../VenueOwnerPlans/VenueOwnerPlanListing";
import { result } from "lodash";
import Swal from "sweetalert2";
import { VenueDate } from "../Utils/common";

export default function VenueOwnerDashboard({
  selectedVenue,
  setIsLoading,
  isLoading,
  venueDetails,
  setVenueDetails,
  setCalendarCourtId,
  activeCalendarID,
  dateid,
  setDateid,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  activeCourtID,
  showoffline,
  isMainPage,
  setIsMainPage,
  setShowoffline,
  venuePlanDetials,
  setVenuePlanDetails,
  showPlanDetails,
  setShowPlanDetails,
  getPlanDetails,
  venueOwnerPlans,
  DashboardFun,
}) {
  const [activeLink, setActiveLink] = useState("booking");
  const [viewType, setViewType] = useState(
    venuePlanDetials?.plan?.name === "Basic Plan" ||
      (venuePlanDetials?.plan?.name !== "Commission Based" &&
        venuePlanDetials?.plan?.name !== "Free Plan" &&
        new Date(venuePlanDetials?.expiryDate) < new Date())
      ? 2
      : 1
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    if (
      venuePlanDetials?.plan?.name === "Basic Plan" ||
      (venuePlanDetials?.plan?.name !== "Commission Based" &&
        venuePlanDetials?.plan?.name !== "Free Plan" &&
        new Date(venuePlanDetials?.expiryDate) < new Date())
    ) {
      setViewType(2);
    }
  }, [venuePlanDetials?.plan?.name]);
  const targetRef = useRef(null);

  const handleNavClick = (link, shouldScroll) => {
    setShowPlanDetails(false);
    setActiveLink(link);
    if (link === "booking" && shouldScroll) {
      targetRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <React.Fragment>
      <div className="d-flex justify-content-between d-flex align-items-center p-3 dashboardHeaderBg">
        <div
          className={`d-flex align-items-center cursor-pointer ${
            activeLink === "dashboard" ? "venueOwnerNavActive" : ""
          }`}
          onClick={() => {
            DashboardFun();
            setDateid(0);
            handleNavClick("dashboard");
            setIsMainPage(true);
          }}
        >
          <img
            src="/images/HomeNavIcon.svg"
            className={`${activeLink === "dashboard" ? "checked-img" : ""}`}
            style={{ height: "23px" }}
          />
          {activeLink === "dashboard" && (
            <span className="Montserrat fw-semibold fs-14 ms-2">Dashboard</span>
          )}
        </div>
        <div
          className={`d-flex align-items-center cursor-pointer ${
            activeLink === "booking" ? "venueOwnerNavActive" : ""
          }`}
          onClick={() => {
            handleNavClick("booking", false);
            setIsMainPage(true);
          }}
        >
          <img
            src="/images/bookedvenues.svg"
            className={`${activeLink === "booking" ? "checked-img" : ""}`}
            style={{ height: "23px" }}
          />
          {activeLink === "booking" && (
            <span
              className="bookings-wrapper pe-3 Montserrat fw-semibold fs-14 ms-2 position-relative"
              style={{
                display: "inline-block",
                position: "relative",
                cursor: "pointer",
              }}
            >
              Bookings
              <select
                className="bookings-custom-select"
                value={viewType}
                onChange={(e) => {
                  if (
                    (venuePlanDetials?.plan?.name === "Basic Plan" ||
                      (venuePlanDetials?.plan?.name !== "Commission Based" &&
                        venuePlanDetials?.plan?.name !== "Free Plan" &&
                        new Date(venuePlanDetials?.expiryDate) < new Date())) &&
                    e.target.value == 1
                  ) {
                    Swal.fire({
                      html: `<div class="font-19 fw-700">To access easy slot view,</div><div class="fw-500">upgrade to the Pro plan.<div>`,
                      showConfirmButton: true,
                      confirmButtonText: "Upgrade Plan",
                      confirmButtonColor: "#E7666A",
                      position: "top",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        setShowPlanDetails(!showPlanDetails);
                      }
                    });
                  } else {
                    setViewType(e.target.value);
                  }
                }}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  opacity: 0,
                  cursor: "pointer",
                  zIndex: 1,
                }}
              >
                <option value={1}>Slot View</option>
                <option value={2}>List View</option>
                <option value={3}>Calendar View</option>
              </select>
            </span>
          )}
        </div>
        <div
          className={`d-flex align-items-center cursor-pointer ${
            activeLink === "staff" ? "venueOwnerNavActive" : ""
          }`}
          onClick={() => {
            handleNavClick("staff");
            setIsMainPage(true);
          }}
        >
          <img
            src="/images/staff-icon.svg"
            className={`${activeLink === "staff" ? "checked-img" : ""}`}
            style={{ height: "23px" }}
          />
          {activeLink === "staff" && (
            <span className="Montserrat fw-semibold fs-14 ms-2">Staff</span>
          )}
        </div>
        <div
          className={`d-flex align-items-center cursor-pointer ${
            activeLink === "package" ? "venueOwnerNavActive" : ""
          }`}
          onClick={() => {
            handleNavClick("package");
            setIsMainPage(true);
          }}
        >
          <img
            src="/images/packageicon.svg"
            className={`${activeLink === "package" ? "checked-img" : ""}`}
            style={{ height: "23px" }}
          />
          {activeLink === "package" && (
            <span className="Montserrat fw-semibold fs-14 ms-2">Package</span>
          )}
        </div>
        <div
          className={`d-flex align-items-center cursor-pointer ${
            activeLink === "settings" ? "venueOwnerNavActive" : ""
          }`}
          onClick={() => {
            handleNavClick("settings");
            setIsMainPage(true);
          }}
        >
          <img
            src="/images/settings-icon.svg"
            className={`${activeLink === "settings" ? "checked-img" : ""}`}
            style={{ height: "23px" }}
          />
          {activeLink === "settings" && (
            <span className="Montserrat fw-semibold fs-14 ms-2">Settings</span>
          )}
        </div>
      </div>
      {venuePlanDetials?.plan && (
        <div className="d-flex justify-content-center align-items-center pb-3 px-3 dashboardHeaderBg">
          <div
            className="w-100"
            style={{ border: "0.5px solid #A51E22", borderRadius: "5px" }}
          >
            <div
              className="d-flex justify-content-between px-3 py-1 bg-white"
              style={{ borderRadius: "5px" }}
            >
              <div className="fw-600">
                {venuePlanDetials?.plan?.name}
                {isMobile && <br />}

                {venuePlanDetials?.expiryDate
                  ? new Date(venuePlanDetials?.expiryDate) < new Date()
                    ? " (Expired)"
                    : ` (Expiring on: ${
                        VenueDate(venuePlanDetials?.expiryDate).formattedDate
                      })`
                  : ""}
              </div>
              <div
                className="clr-A51E22 fw-600 text-decoration-underline align-content-center"
                onClick={() => {
                  setShowPlanDetails(!showPlanDetails);
                }}
              >
                {!showPlanDetails ? "View Details" : "Hide Details"}
              </div>
            </div>
          </div>
        </div>
      )}

      {isLoading ? (
        <Loader mt="20%" />
      ) : (
        <div
          style={{
            overflow: "auto",
            position: "relative",
            maxHeight: "calc(100vh - 168px)",
            paddingBottom: "0%",
          }}
        >
          {showPlanDetails ? (
            <>
              <VenueOwnerPlanListing
                venueID={selectedVenue}
                venuePlanDetials={venuePlanDetials}
                getPlanDetails={getPlanDetails}
                venueOwnerPlans={venueOwnerPlans}
              />
            </>
          ) : (
            <>
              {activeLink === "dashboard" && (
                <VenueOwnerDashbooard
                  dateid={dateid}
                  setDateid={setDateid}
                  venueDetails={venueDetails}
                  setVenueDetails={setVenueDetails}
                  selectedVenue={selectedVenue}
                  setActiveLink={setActiveLink}
                  activeCalendarID={activeCalendarID}
                  setCalendarCourtId={setCalendarCourtId}
                  setEndDate={setEndDate}
                  setStartDate={setStartDate}
                  startDate={startDate}
                  endDate={endDate}
                  setIsLoading={setIsLoading}
                  venuePlanDetials={venuePlanDetials}
                />
              )}
              {activeLink === "booking" && (
                <VenueOwnerDashbooardBooking
                  selectedVenue={selectedVenue}
                  setIsLoading={setIsLoading}
                  isLoading={isLoading}
                  activeCourtID={activeCourtID}
                  showoffline={showoffline}
                  viewType={viewType}
                  setShowoffline={setShowoffline}
                />
              )}
              {activeLink === "staff" && (
                <StaffMembers
                  venueID={selectedVenue}
                  venuePlanDetials={venuePlanDetials}
                  showPlanDetails={showPlanDetails}
                  setShowPlanDetails={setShowPlanDetails}
                />
              )}
              {activeLink === "package" && (
                <PackagesDetails venueID={selectedVenue} />
              )}
              {activeLink === "settings" && (
                <VenueDashboardEditDetails
                  venueID={selectedVenue}
                  venueDetails={venueDetails}
                  setIsMainPage={setIsMainPage}
                  isMainPage={isMainPage}
                  activeCourtID={activeCourtID}
                  DashboardFun={DashboardFun}
                />
              )}
            </>
          )}
        </div>
      )}
    </React.Fragment>
  );
}
